<ng-container thr-parent-form>
    <thr-contract-form-participant-minor-disabled-person
        [client]="client"
        [isFirst]="true"
    ></thr-contract-form-participant-minor-disabled-person>
</ng-container>
